<template>
  <div style="display: none"></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "BorderLayer",
  props: {
    /**
     * Indicates whether the MapBox instance is ready
     */
    loaded: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('access', [
      'getActiveMunicipality'
    ]),
    ...mapGetters('prognose', [
      'labelLayer'
    ])
  },
  watch: {
    getActiveMunicipality(code) {
      // Update layer filter
      if (!this.loaded || ! this.$store.map.getLayer('border')) return

      this.$store.map.setPaintProperty(
        'border', 
        'line-opacity', 
        this.opacityByCode({ code })
      )
    },
    loaded(loaded) {
      if (!loaded) return

      this.addBorder()
    }
  },
  created() {
    if (this.loaded) {
      this.addBorder()
    }
  },
  methods: {
    /**
     * Add the border layer
     */
    addBorder() {
      if (! process.env.VUE_APP_GEMEENTEGRENZEN_URL || ! process.env.VUE_APP_GEMEENTEGRENZEN_SOURCE) return

      if (this.$store.map.getLayer('border')) {
        console.log("remove border layer")
        this.$store.map.removeLayer('border')
      }
      if (this.$store.map.getSource('border')) {
        console.log("remove border source")
        this.$store.map.removeSource('border')
      }
      
      this.$nextTick(() => {
        this.$store.map.addSource('border', {
          type: 'vector',
          url: process.env.VUE_APP_GEMEENTEGRENZEN_URL
        })

        this.$store.map.addLayer({ 
          "id": "border",
          "type": "line",
          "source": "border",
          "source-layer": process.env.VUE_APP_GEMEENTEGRENZEN_SOURCE,
          "paint": {
            "line-color": "hsla(23, 100%, 62%, 1)",
            "line-opacity": this.opacityByCode({ code: this.getActiveMunicipality }),
            "line-width": 2
          }
        }, this.labelLayer)
      })
    },
    /**
     * Generate the fill-opacity style spec
     */
    opacityByCode({ code }) {
      return [
        "match",
        ['get', 'gemeentecode'],
        code, 1,
        0
      ]
    }
  }
}
</script>
